RivalIQ.apps.LandscapeSettings.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.Email = Backbone.Model.extend({
        idAttribute: 'email'
    });
});
